<div bp-goal-detail-card>
  <div>
    @if (isGeneralBalance) {
      <div class="truncate text-xl font-bold pb-6 hidden sm:block">Evolución Balance</div>
      <div class="w-full h1 mt-auto border-t-2 hidden sm:block"></div>
      <div class="flex flex-row justify-stretch pt-0 sm:pt-6 pb-6">
        <div class="flex flex-col w-full gap-1">
          <div class="truncate">Balance</div>
          <div class="text-3xl font-semibold leading-6 tracking-tight">$0.00</div>
          <div class="text-base sm:hidden block">
            <span class="text-charts-green-700"> $0.00 </span>
            variación
            @if (groupFilterInfo?.timePeriod?.value === 7) {
              <span class="lowercase">
                {{ groupFilterInfo?.timePeriod?.initialDate }} -
                {{ groupFilterInfo?.timePeriod?.initialDate }}</span
              >
            } @else {
              <span class="lowercase"> {{ groupFilterInfo?.timePeriod?.labels?.[0] }}</span>
            }
          </div>
        </div>
        <div class="flex flex-col w-full hidden sm:flex gap-1">
          <div class="truncate">
            Variación
            @if (groupFilterInfo?.timePeriod?.value === 7) {
              <span class="lowercase">
                {{ groupFilterInfo?.timePeriod?.initialDate }} -
                {{ groupFilterInfo?.timePeriod?.initialDate }}</span
              >
            } @else {
              <span class="lowercase"> {{ groupFilterInfo?.timePeriod?.labels?.[0] }}</span>
            }
          </div>
          <div class="text-3xl font-semibold leading-6 tracking-tight">$0.00</div>
        </div>
      </div>
    } @else {
      <div bp-title-card class="truncate">Balance</div>
    }
    @if (showDates && !isGeneralBalance) {
      <div bp-text-values-card class="truncate">
        {{ fixedFromDate + ' - ' + fixedToDate }}
      </div>
    }
  </div>
  <div class="flex flex-col justify-between">
    <!-- Chart -->
    <div class="flex-1 px-0 pt-0">
      <div style="width: 100%">
        @if (!isLoading && !singleChart) {
          <app-g-p-b-chart [balance]="balance" [currency]="currency"></app-g-p-b-chart>
        }
        @if (!isLoading && singleChart) {
          <app-g-p-b-chart-single
            [balance]="balanceSingle"
            [currency]="currency"
          ></app-g-p-b-chart-single>
        }
      </div>
    </div>
    <div>
      @if (hasAllFinancialInstitutions) {
        <p class="py-2 text-left help-text">
          El gráfico muestra los datos hasta el último día en que ambas instituciones tienen el
          valor de sus fondos publicados.
        </p>
      }
    </div>

    @if (isGeneralBalance) {
      <!-- Habilitar detalle on and off -->
      <a [ngClass]="showDetailTable ? 'pb-6' : ''" bp-link (click)="showDetailTableToggle()">
        @if (showDetailTable) {
          Ocultar
        } @else {
          Mostrar
        }
        desglose de información</a
      >
    }
    @if (showDetailTable || !isGeneralBalance) {
      <!-- Table -->
      <app-g-p-b-table
        @fadeIn
        [totalCurrentCapital]="totalCurrentCapital"
        [dateFinalBalance]="dateFinalBalance"
        [hasAllFinancialInstitutions]="hasAllFinancialInstitutions"
        [balanceTotalAmount]="balanceTotalAmount"
        [balanceTotalDate]="balanceTotalDate"
        [deposits]="deposits"
        [withdrawals]="withdrawals"
        [balanceInitDate]="balanceInitDate"
        [netDeposit]="netDeposit"
        [balanceInitAmount]="balanceInitAmount"
        [currency]="currency"
        [variation]="variation"
        [irrAccumulated]="irrAccumulated"
        [irrAccumulatedUSD]="irrAccumulatedUSD"
        [isGeneralBalance]="isGeneralBalance"
      >
      </app-g-p-b-table>
    }
  </div>
</div>
